import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  declarationId: string;
}

export const useSendProvidedDocuments = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ declarationId }: HookProps) => {
    await request({
      path: `idms/send-documents/${declarationId}`,
      method: 'POST',
      authenticate: true,
    });
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
      toast.success('Documents sent successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending documents!`);
    },
  });
};
